export const STATUS_LABELS = {
  draft: 'Borrador',
  reviewed: 'Revisado',
  approved: 'Aprobado',
  sent_to_bsale: 'Enviado a BSale',
  invoiced: 'Facturado',
  rejected: 'Rechazado',
  cancelled: 'Cancelado',
};

// Tono del soft-pill tokenizado (coincide con .bill-badge--<tono>).
export const STATUS_TONE = {
  draft: 'neutral',
  reviewed: 'info',
  approved: 'success',
  sent_to_bsale: 'reverse',
  invoiced: 'cc',
  rejected: 'error',
  cancelled: 'neutral',
};

export const TYPE_LABELS = {
  client_invoice: 'Factura a Cliente',
  driver_payment: 'Pago a Repartidor',
};

export const DEDUCTION_CATEGORIES = [
  { value: 'paquete_roto', label: 'Paquete roto' },
  { value: 'paquete_perdido', label: 'Paquete perdido' },
  { value: 'error_entrega', label: 'Error de entrega' },
  { value: 'otro', label: 'Otro' },
];

export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '$0';
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
  }).format(Math.round(amount));
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('es-CL', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const formatPeriod = (start, end) => {
  if (!start) return '-';
  const s = formatDate(start);
  const e = end ? formatDate(end) : '';
  return e ? `${s} – ${e}` : s;
};

export const isEditable = (status) =>
  status === 'draft' || status === 'reviewed';

export const canApprove = (status) =>
  status === 'draft' || status === 'reviewed';

export const canSendToBsale = (status) => status === 'approved';

export const canReject = (status) =>
  !['invoiced', 'cancelled', 'rejected'].includes(status);
